interface ChangePriorityData {
  id: number;
  priority: number;
}

/**
 * Změna priritizace jednoho objektu v poli
 *
 * - parametr data musí být pole objektů, kde každý objekt musí mít min. strukturu :
 * {
 *   id: number;
 *   priority: number;
 * }
 *
 * @param {Array<any>} data
 * @param movedObject
 * @param {number} prevPriority
 * @param {number} newPriority
 * @returns {any}
 */
export const changePriority = (data: Array<ChangePriorityData>, movedObject: any, prevPriority: number, newPriority: number) => {
  let reprioritized = Array<ChangePriorityData>();

  // kolize v prioritách
  const collisionData = data.find((d: any) => d.priority === newPriority);

  // projdu všechny objekty v poli
  for (let i = 0; i < data.length; ++i) {
    const d = data[i];
    let found = false;
    if ((d.priority >= prevPriority && d.priority <= newPriority) || (d.priority >= newPriority && d.priority <= prevPriority)) {
      // objekt, která se přesouvá
      if (movedObject && (d.id === movedObject.id)) {
        reprioritized.push({ ...d, priority: newPriority });
        found = true;
      } else {
        // došlo ke kolizi objektů
        // tzn. snažím se nějaký objekt přesunout na pozici
        if (collisionData) {
          // směr posunutí objektu
          // podle toho zda posouvám objekt nahoru nebo dolu
          if (prevPriority > newPriority) {
            reprioritized.push({ ...d, priority: d.priority + 1 });
            found = true;
          } else {
            reprioritized.push({ ...d, priority: d.priority - 1 });
            found = true;
          }
        }
      }
    }

    if (!found) {
      reprioritized.push({...d});
    }
  }

  // console.log('reprioritized', reprioritized);

  return reprioritized;
}



// WEBPACK FOOTER //
// ./src/helpers/Data/changePriority.ts